/* js/components/HaltePodcastAndVideo.svelte generated by Svelte v3.46.4 */
import {
	HtmlTag,
	SvelteComponent,
	add_flush_callback,
	append,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_style,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import { Facebook, Twitter } from './socialShare';
import PlyrAudioPlayer from './PlyrAudioPlayer.svelte';
import PlyrVideoPlayer from './PlyrVideoPlayer.svelte';
import Header from './Header.svelte';
import ParcoursPath from './ParcoursPath.svelte';
import { Button, Ripple } from 'svelte-mui';
import HyperButton from './HyperButton.svelte';
import ShareButton from './ShareButton.svelte';
import MapLibre from './MapLibre.svelte';
import UserMarkerLibre from './UserMarkerLibre.svelte';
import SpotMarkerLibre from './SpotMarkerLibre.svelte';
import GeoLocationStartButton from './GeoLocationStartButton.svelte';

import {
	geoLocationManager,
	GeolocationEventType,
	GeoLocationServiceState
} from '../GeoLocationManager';

import { computeBounds, lineFeatureCollectionFromPoints } from '../geoUtils';
import { getBbox } from '../geoUtils';
import { flyToProvider } from '../providers';
import { Config } from '../config';
import { db } from '../Db';
import { appRouter } from '../appRouter.js';
import { onMount, onDestroy } from 'svelte';
import computeUrl from '../url';
import MenuModal from './MenuModal.svelte';
import * as animateScroll from "svelte-scrollto";
import { StepType } from '../StepType';
import { HalteParentType } from '../HalteParentType';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[30] = list[i];
	child_ctx[32] = i;
	return child_ctx;
}

// (200:4) {:else}
function create_else_block_2(ctx) {
	let div1;
	let div0;
	let plyrvideoplayer;
	let current;

	plyrvideoplayer = new PlyrVideoPlayer({
			props: { src: /*halte*/ ctx[0].media.mediaUrl }
		});

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			create_component(plyrvideoplayer.$$.fragment);
			attr(div0, "class", "videoplayer svelte-rabi4t");
			attr(div1, "class", "mainElementsVideo svelte-rabi4t");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			mount_component(plyrvideoplayer, div0, null);
			current = true;
		},
		p(ctx, dirty) {
			const plyrvideoplayer_changes = {};
			if (dirty[0] & /*halte*/ 1) plyrvideoplayer_changes.src = /*halte*/ ctx[0].media.mediaUrl;
			plyrvideoplayer.$set(plyrvideoplayer_changes);
		},
		i(local) {
			if (current) return;
			transition_in(plyrvideoplayer.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(plyrvideoplayer.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			destroy_component(plyrvideoplayer);
		}
	};
}

// (194:4) {#if halte.type == StepType.podcast}
function create_if_block_10(ctx) {
	let div;
	let h1;
	let t_value = /*halte*/ ctx[0].title + "";
	let t;

	return {
		c() {
			div = element("div");
			h1 = element("h1");
			t = text(t_value);
			attr(h1, "class", "section-audioplayer svelte-rabi4t");
			attr(div, "class", "mainElements svelte-rabi4t");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, h1);
			append(h1, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*halte*/ 1 && t_value !== (t_value = /*halte*/ ctx[0].title + "")) set_data(t, t_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (213:0) {#if halte.type == StepType.podcast}
function create_if_block_9(ctx) {
	let div2;
	let div1;
	let figure;
	let div0;
	let plyraudioplayer;
	let current;

	plyraudioplayer = new PlyrAudioPlayer({
			props: {
				class: "audioplayer",
				src: appRouter.normalizePath(/*halte*/ ctx[0].media.podcast)
			}
		});

	return {
		c() {
			div2 = element("div");
			div1 = element("div");
			figure = element("figure");
			div0 = element("div");
			create_component(plyraudioplayer.$$.fragment);
			attr(div0, "class", "herobutton");
			attr(figure, "class", "svelte-rabi4t");
			attr(div1, "class", "column svelte-rabi4t");
			attr(div2, "class", "section-container");
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, div1);
			append(div1, figure);
			append(figure, div0);
			mount_component(plyraudioplayer, div0, null);
			current = true;
		},
		p(ctx, dirty) {
			const plyraudioplayer_changes = {};
			if (dirty[0] & /*halte*/ 1) plyraudioplayer_changes.src = appRouter.normalizePath(/*halte*/ ctx[0].media.podcast);
			plyraudioplayer.$set(plyraudioplayer_changes);
		},
		i(local) {
			if (current) return;
			transition_in(plyraudioplayer.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(plyraudioplayer.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div2);
			destroy_component(plyraudioplayer);
		}
	};
}

// (245:4) {:else}
function create_else_block_1(ctx) {
	let h2;
	let t1;
	let hyperbutton;
	let current;

	hyperbutton = new HyperButton({
			props: {
				class: "button",
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	hyperbutton.$on("click", /*gotoAcceuilParcours*/ ctx[12]);

	return {
		c() {
			h2 = element("h2");
			h2.textContent = "Vous êtes arrivé-e à la fin du parcours.";
			t1 = space();
			create_component(hyperbutton.$$.fragment);
		},
		m(target, anchor) {
			insert(target, h2, anchor);
			insert(target, t1, anchor);
			mount_component(hyperbutton, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const hyperbutton_changes = {};

			if (dirty[1] & /*$$scope*/ 4) {
				hyperbutton_changes.$$scope = { dirty, ctx };
			}

			hyperbutton.$set(hyperbutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(hyperbutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hyperbutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h2);
			if (detaching) detach(t1);
			destroy_component(hyperbutton, detaching);
		}
	};
}

// (240:4) {#if nextHalte}
function create_if_block_8(ctx) {
	let h2;
	let t0;
	let br0;
	let t1;
	let t2_value = /*nextHalte*/ ctx[1].title + "";
	let t2;
	let br1;
	let br2;
	let t3;
	let hyperbutton;
	let current;

	hyperbutton = new HyperButton({
			props: {
				class: "button",
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	hyperbutton.$on("click", /*gotoNextEnChemin*/ ctx[11]);

	return {
		c() {
			h2 = element("h2");
			t0 = text("La prochaine halte:");
			br0 = element("br");
			t1 = space();
			t2 = text(t2_value);
			br1 = element("br");
			br2 = element("br");
			t3 = space();
			create_component(hyperbutton.$$.fragment);
		},
		m(target, anchor) {
			insert(target, h2, anchor);
			append(h2, t0);
			append(h2, br0);
			append(h2, t1);
			append(h2, t2);
			append(h2, br1);
			append(h2, br2);
			insert(target, t3, anchor);
			mount_component(hyperbutton, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*nextHalte*/ 2) && t2_value !== (t2_value = /*nextHalte*/ ctx[1].title + "")) set_data(t2, t2_value);
			const hyperbutton_changes = {};

			if (dirty[1] & /*$$scope*/ 4) {
				hyperbutton_changes.$$scope = { dirty, ctx };
			}

			hyperbutton.$set(hyperbutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(hyperbutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hyperbutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h2);
			if (detaching) detach(t3);
			destroy_component(hyperbutton, detaching);
		}
	};
}

// (247:8) <HyperButton class="button" on:click={gotoAcceuilParcours} >
function create_default_slot_11(ctx) {
	let t;

	return {
		c() {
			t = text("Retour à l'accueil des parcours");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (243:8) <HyperButton class="button" on:click={gotoNextEnChemin} >
function create_default_slot_10(ctx) {
	let t;

	return {
		c() {
			t = text("Poursuivre le parcours");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (257:8) {#if halteContent}
function create_if_block_7(ctx) {
	let html_tag;
	let html_anchor;

	return {
		c() {
			html_tag = new HtmlTag();
			html_anchor = empty();
			html_tag.a = html_anchor;
		},
		m(target, anchor) {
			html_tag.m(/*halteContent*/ ctx[7], target, anchor);
			insert(target, html_anchor, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*halteContent*/ 128) html_tag.p(/*halteContent*/ ctx[7]);
		},
		d(detaching) {
			if (detaching) detach(html_anchor);
			if (detaching) html_tag.d();
		}
	};
}

// (271:4) {:else}
function create_else_block(ctx) {
	let h2;
	let t1;
	let hyperbutton;
	let current;

	hyperbutton = new HyperButton({
			props: {
				class: "button",
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	hyperbutton.$on("click", /*gotoAcceuilParcours*/ ctx[12]);

	return {
		c() {
			h2 = element("h2");
			h2.textContent = "Vous êtes arrivé-e à la fin du parcours.";
			t1 = space();
			create_component(hyperbutton.$$.fragment);
			attr(h2, "class", "section-map");
		},
		m(target, anchor) {
			insert(target, h2, anchor);
			insert(target, t1, anchor);
			mount_component(hyperbutton, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const hyperbutton_changes = {};

			if (dirty[1] & /*$$scope*/ 4) {
				hyperbutton_changes.$$scope = { dirty, ctx };
			}

			hyperbutton.$set(hyperbutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(hyperbutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hyperbutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h2);
			if (detaching) detach(t1);
			destroy_component(hyperbutton, detaching);
		}
	};
}

// (266:4) {#if nextHalte}
function create_if_block_6(ctx) {
	let h2;
	let t0;
	let br0;
	let t1;
	let t2_value = /*nextHalte*/ ctx[1].title + "";
	let t2;
	let br1;
	let br2;
	let t3;
	let hyperbutton;
	let current;

	hyperbutton = new HyperButton({
			props: {
				class: "button section-map",
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	hyperbutton.$on("click", /*gotoNextEnChemin*/ ctx[11]);

	return {
		c() {
			h2 = element("h2");
			t0 = text("La prochaine halte:");
			br0 = element("br");
			t1 = space();
			t2 = text(t2_value);
			br1 = element("br");
			br2 = element("br");
			t3 = space();
			create_component(hyperbutton.$$.fragment);
		},
		m(target, anchor) {
			insert(target, h2, anchor);
			append(h2, t0);
			append(h2, br0);
			append(h2, t1);
			append(h2, t2);
			append(h2, br1);
			append(h2, br2);
			insert(target, t3, anchor);
			mount_component(hyperbutton, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*nextHalte*/ 2) && t2_value !== (t2_value = /*nextHalte*/ ctx[1].title + "")) set_data(t2, t2_value);
			const hyperbutton_changes = {};

			if (dirty[1] & /*$$scope*/ 4) {
				hyperbutton_changes.$$scope = { dirty, ctx };
			}

			hyperbutton.$set(hyperbutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(hyperbutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hyperbutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h2);
			if (detaching) detach(t3);
			destroy_component(hyperbutton, detaching);
		}
	};
}

// (273:8) <HyperButton class="button" on:click={gotoAcceuilParcours} >
function create_default_slot_9(ctx) {
	let t;

	return {
		c() {
			t = text("Retour à l'accueil des parcours");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (269:8) <HyperButton class="button section-map" on:click={gotoNextEnChemin} >
function create_default_slot_8(ctx) {
	let t;

	return {
		c() {
			t = text("Poursuivre le parcours");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (288:12) {#if parcoursPath && mapIsReady}
function create_if_block_5(ctx) {
	let parcourspath;
	let t;
	let each_1_anchor;
	let current;

	parcourspath = new ParcoursPath({
			props: {
				pathData: /*parcoursPath*/ ctx[3],
				parcoursSlug: /*halte*/ ctx[0].parentSlug,
				pathColor: "#222",
				lineWidth: 6
			}
		});

	let each_value = /*haltePoints*/ ctx[4];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			create_component(parcourspath.$$.fragment);
			t = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			mount_component(parcourspath, target, anchor);
			insert(target, t, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const parcourspath_changes = {};
			if (dirty[0] & /*parcoursPath*/ 8) parcourspath_changes.pathData = /*parcoursPath*/ ctx[3];
			if (dirty[0] & /*halte*/ 1) parcourspath_changes.parcoursSlug = /*halte*/ ctx[0].parentSlug;
			parcourspath.$set(parcourspath_changes);

			if (dirty[0] & /*haltePoints, halte*/ 17) {
				each_value = /*haltePoints*/ ctx[4];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(parcourspath.$$.fragment, local);

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			transition_out(parcourspath.$$.fragment, local);
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_component(parcourspath, detaching);
			if (detaching) detach(t);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (290:16) {#each haltePoints as haltePoint, index}
function create_each_block(ctx) {
	let spotmarkerlibre;
	let current;

	spotmarkerlibre = new SpotMarkerLibre({
			props: {
				id: /*index*/ ctx[32],
				isLast: /*index*/ ctx[32] == /*haltePoints*/ ctx[4].length - 1,
				coords: /*haltePoint*/ ctx[30],
				isCurrent: /*index*/ ctx[32] == /*halte*/ ctx[0].idx,
				zIndex: /*index*/ ctx[32] == /*halte*/ ctx[0].idx
				? 19
				: /*haltePoints*/ ctx[4].length - /*index*/ ctx[32]
			}
		});

	return {
		c() {
			create_component(spotmarkerlibre.$$.fragment);
		},
		m(target, anchor) {
			mount_component(spotmarkerlibre, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const spotmarkerlibre_changes = {};
			if (dirty[0] & /*haltePoints*/ 16) spotmarkerlibre_changes.isLast = /*index*/ ctx[32] == /*haltePoints*/ ctx[4].length - 1;
			if (dirty[0] & /*haltePoints*/ 16) spotmarkerlibre_changes.coords = /*haltePoint*/ ctx[30];
			if (dirty[0] & /*halte*/ 1) spotmarkerlibre_changes.isCurrent = /*index*/ ctx[32] == /*halte*/ ctx[0].idx;

			if (dirty[0] & /*halte, haltePoints*/ 17) spotmarkerlibre_changes.zIndex = /*index*/ ctx[32] == /*halte*/ ctx[0].idx
			? 19
			: /*haltePoints*/ ctx[4].length - /*index*/ ctx[32];

			spotmarkerlibre.$set(spotmarkerlibre_changes);
		},
		i(local) {
			if (current) return;
			transition_in(spotmarkerlibre.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(spotmarkerlibre.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(spotmarkerlibre, detaching);
		}
	};
}

// (285:8) <MapLibre onLoad={onMapLoaded} interactive={false} pitch=0>
function create_default_slot_7(ctx) {
	let usermarkerlibre;
	let t0;
	let geolocationstartbutton;
	let t1;
	let if_block_anchor;
	let current;
	usermarkerlibre = new UserMarkerLibre({});
	geolocationstartbutton = new GeoLocationStartButton({});
	let if_block = /*parcoursPath*/ ctx[3] && /*mapIsReady*/ ctx[10] && create_if_block_5(ctx);

	return {
		c() {
			create_component(usermarkerlibre.$$.fragment);
			t0 = space();
			create_component(geolocationstartbutton.$$.fragment);
			t1 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			mount_component(usermarkerlibre, target, anchor);
			insert(target, t0, anchor);
			mount_component(geolocationstartbutton, target, anchor);
			insert(target, t1, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*parcoursPath*/ ctx[3] && /*mapIsReady*/ ctx[10]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty[0] & /*parcoursPath, mapIsReady*/ 1032) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_5(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(usermarkerlibre.$$.fragment, local);
			transition_in(geolocationstartbutton.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(usermarkerlibre.$$.fragment, local);
			transition_out(geolocationstartbutton.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			destroy_component(usermarkerlibre, detaching);
			if (detaching) detach(t0);
			destroy_component(geolocationstartbutton, detaching);
			if (detaching) detach(t1);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (304:4) {#if hasBonus && bonusContent}
function create_if_block_4(ctx) {
	let section;

	return {
		c() {
			section = element("section");
			attr(section, "class", "section-bonus");
		},
		m(target, anchor) {
			insert(target, section, anchor);
			section.innerHTML = /*bonusContent*/ ctx[8];
		},
		p(ctx, dirty) {
			if (dirty[0] & /*bonusContent*/ 256) section.innerHTML = /*bonusContent*/ ctx[8];;
		},
		d(detaching) {
			if (detaching) detach(section);
		}
	};
}

// (310:4) {#if hasBiblio && biblioContent}
function create_if_block_3(ctx) {
	let section;

	return {
		c() {
			section = element("section");
			attr(section, "class", "section-bibliography");
		},
		m(target, anchor) {
			insert(target, section, anchor);
			section.innerHTML = /*biblioContent*/ ctx[9];
		},
		p(ctx, dirty) {
			if (dirty[0] & /*biblioContent*/ 512) section.innerHTML = /*biblioContent*/ ctx[9];;
		},
		d(detaching) {
			if (detaching) detach(section);
		}
	};
}

// (319:8) <Button on:click={gotoTop} color="#eeeeee" unelevated fullWidth>
function create_default_slot_6(ctx) {
	let t;

	return {
		c() {
			t = text("Titre");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (322:8) <Button on:click={() => gotoSection('.section-text')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_5(ctx) {
	let t;

	return {
		c() {
			t = text("Texte");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (325:8) <Button on:click={() => gotoSection('.section-map')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_4(ctx) {
	let t;

	return {
		c() {
			t = text("Carte");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (328:8) {#if hasBonus && bonusContent}
function create_if_block_2(ctx) {
	let button;
	let t;
	let div;
	let current;

	button = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*click_handler_4*/ ctx[20]);

	return {
		c() {
			create_component(button.$$.fragment);
			t = space();
			div = element("div");
			attr(div, "class", "spacer");
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			insert(target, t, anchor);
			insert(target, div, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = {};

			if (dirty[1] & /*$$scope*/ 4) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
			if (detaching) detach(t);
			if (detaching) detach(div);
		}
	};
}

// (329:12) <Button on:click={() => gotoSection('.section-bonus')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_3(ctx) {
	let t;

	return {
		c() {
			t = text("Bonus");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (333:8) {#if hasBiblio && biblioContent}
function create_if_block_1(ctx) {
	let button;
	let t;
	let div;
	let current;

	button = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*click_handler_5*/ ctx[21]);

	return {
		c() {
			create_component(button.$$.fragment);
			t = space();
			div = element("div");
			attr(div, "class", "spacer");
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			insert(target, t, anchor);
			insert(target, div, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = {};

			if (dirty[1] & /*$$scope*/ 4) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
			if (detaching) detach(t);
			if (detaching) detach(div);
		}
	};
}

// (334:12) <Button on:click={() => gotoSection('.section-bibliography')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_2(ctx) {
	let t;

	return {
		c() {
			t = text("Bibliographie");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (338:8) {#if nextHalte}
function create_if_block(ctx) {
	let button;
	let t;
	let div;
	let current;

	button = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*click_handler_6*/ ctx[22]);

	return {
		c() {
			create_component(button.$$.fragment);
			t = space();
			div = element("div");
			attr(div, "class", "spacer");
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			insert(target, t, anchor);
			insert(target, div, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = {};

			if (dirty[1] & /*$$scope*/ 4) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
			if (detaching) detach(t);
			if (detaching) detach(div);
		}
	};
}

// (339:12) <Button on:click={() => gotoSection('.section-poursuivre')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_1(ctx) {
	let t;

	return {
		c() {
			t = text("Prochaine halte");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (317:4) <MenuModal bind:open={sectionModalVisible}>
function create_default_slot(ctx) {
	let button0;
	let t0;
	let div0;
	let t1;
	let button1;
	let t2;
	let div1;
	let t3;
	let button2;
	let t4;
	let div2;
	let t5;
	let t6;
	let t7;
	let if_block2_anchor;
	let current;

	button0 = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	button0.$on("click", /*gotoTop*/ ctx[14]);

	button1 = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	button1.$on("click", /*click_handler_2*/ ctx[18]);

	button2 = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	button2.$on("click", /*click_handler_3*/ ctx[19]);
	let if_block0 = /*hasBonus*/ ctx[5] && /*bonusContent*/ ctx[8] && create_if_block_2(ctx);
	let if_block1 = /*hasBiblio*/ ctx[6] && /*biblioContent*/ ctx[9] && create_if_block_1(ctx);
	let if_block2 = /*nextHalte*/ ctx[1] && create_if_block(ctx);

	return {
		c() {
			create_component(button0.$$.fragment);
			t0 = space();
			div0 = element("div");
			t1 = space();
			create_component(button1.$$.fragment);
			t2 = space();
			div1 = element("div");
			t3 = space();
			create_component(button2.$$.fragment);
			t4 = space();
			div2 = element("div");
			t5 = space();
			if (if_block0) if_block0.c();
			t6 = space();
			if (if_block1) if_block1.c();
			t7 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
			attr(div0, "class", "spacer");
			attr(div1, "class", "spacer");
			attr(div2, "class", "spacer");
		},
		m(target, anchor) {
			mount_component(button0, target, anchor);
			insert(target, t0, anchor);
			insert(target, div0, anchor);
			insert(target, t1, anchor);
			mount_component(button1, target, anchor);
			insert(target, t2, anchor);
			insert(target, div1, anchor);
			insert(target, t3, anchor);
			mount_component(button2, target, anchor);
			insert(target, t4, anchor);
			insert(target, div2, anchor);
			insert(target, t5, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t6, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, t7, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button0_changes = {};

			if (dirty[1] & /*$$scope*/ 4) {
				button0_changes.$$scope = { dirty, ctx };
			}

			button0.$set(button0_changes);
			const button1_changes = {};

			if (dirty[1] & /*$$scope*/ 4) {
				button1_changes.$$scope = { dirty, ctx };
			}

			button1.$set(button1_changes);
			const button2_changes = {};

			if (dirty[1] & /*$$scope*/ 4) {
				button2_changes.$$scope = { dirty, ctx };
			}

			button2.$set(button2_changes);

			if (/*hasBonus*/ ctx[5] && /*bonusContent*/ ctx[8]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[0] & /*hasBonus, bonusContent*/ 288) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_2(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t6.parentNode, t6);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*hasBiblio*/ ctx[6] && /*biblioContent*/ ctx[9]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*hasBiblio, biblioContent*/ 576) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(t7.parentNode, t7);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (/*nextHalte*/ ctx[1]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*nextHalte*/ 2) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(button0.$$.fragment, local);
			transition_in(button1.$$.fragment, local);
			transition_in(button2.$$.fragment, local);
			transition_in(if_block0);
			transition_in(if_block1);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(button0.$$.fragment, local);
			transition_out(button1.$$.fragment, local);
			transition_out(button2.$$.fragment, local);
			transition_out(if_block0);
			transition_out(if_block1);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			destroy_component(button0, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div0);
			if (detaching) detach(t1);
			destroy_component(button1, detaching);
			if (detaching) detach(t2);
			if (detaching) detach(div1);
			if (detaching) detach(t3);
			destroy_component(button2, detaching);
			if (detaching) detach(t4);
			if (detaching) detach(div2);
			if (detaching) detach(t5);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t6);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t7);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

function create_fragment(ctx) {
	let header;
	let t0;
	let div2;
	let div0;
	let ripple0;
	let t1;
	let t2;
	let div1;
	let ripple1;
	let t3;
	let img0;
	let img0_src_value;
	let t4;
	let sharebutton;
	let t5;
	let div3;
	let t6;
	let div4;
	let img1;
	let img1_src_value;
	let t7;
	let current_block_type_index;
	let if_block0;
	let t8;
	let t9;
	let div8;
	let section0;
	let t10;
	let current_block_type_index_1;
	let if_block2;
	let t11;
	let br0;
	let br1;
	let br2;
	let br3;
	let t12;
	let section1;
	let t13;
	let br4;
	let br5;
	let br6;
	let t14;
	let current_block_type_index_2;
	let if_block4;
	let t15;
	let div5;
	let t16;
	let br7;
	let br8;
	let t17;
	let div6;
	let maplibre;
	let t18;
	let br9;
	let br10;
	let t19;
	let t20;
	let t21;
	let menumodal;
	let updating_open;
	let t22;
	let div7;
	let current;
	let mounted;
	let dispose;
	header = new Header({ props: { title: "Halte" } });
	ripple0 = new Ripple({ props: { center: true } });
	ripple1 = new Ripple({ props: { center: true } });
	sharebutton = new ShareButton({ props: { url: computeUrl() } });
	const if_block_creators = [create_if_block_10, create_else_block_2];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*halte*/ ctx[0].type == StepType.podcast) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, [-1, -1]);
	if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	let if_block1 = /*halte*/ ctx[0].type == StepType.podcast && create_if_block_9(ctx);
	const if_block_creators_1 = [create_if_block_8, create_else_block_1];
	const if_blocks_1 = [];

	function select_block_type_1(ctx, dirty) {
		if (/*nextHalte*/ ctx[1]) return 0;
		return 1;
	}

	current_block_type_index_1 = select_block_type_1(ctx, [-1, -1]);
	if_block2 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx);
	let if_block3 = /*halteContent*/ ctx[7] && create_if_block_7(ctx);
	const if_block_creators_2 = [create_if_block_6, create_else_block];
	const if_blocks_2 = [];

	function select_block_type_2(ctx, dirty) {
		if (/*nextHalte*/ ctx[1]) return 0;
		return 1;
	}

	current_block_type_index_2 = select_block_type_2(ctx, [-1, -1]);
	if_block4 = if_blocks_2[current_block_type_index_2] = if_block_creators_2[current_block_type_index_2](ctx);

	maplibre = new MapLibre({
			props: {
				onLoad: /*onMapLoaded*/ ctx[15],
				interactive: false,
				pitch: "0",
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	let if_block5 = /*hasBonus*/ ctx[5] && /*bonusContent*/ ctx[8] && create_if_block_4(ctx);
	let if_block6 = /*hasBiblio*/ ctx[6] && /*biblioContent*/ ctx[9] && create_if_block_3(ctx);

	function menumodal_open_binding(value) {
		/*menumodal_open_binding*/ ctx[23](value);
	}

	let menumodal_props = {
		$$slots: { default: [create_default_slot] },
		$$scope: { ctx }
	};

	if (/*sectionModalVisible*/ ctx[2] !== void 0) {
		menumodal_props.open = /*sectionModalVisible*/ ctx[2];
	}

	menumodal = new MenuModal({ props: menumodal_props });
	binding_callbacks.push(() => bind(menumodal, 'open', menumodal_open_binding));

	return {
		c() {
			create_component(header.$$.fragment);
			t0 = space();
			div2 = element("div");
			div0 = element("div");
			create_component(ripple0.$$.fragment);
			t1 = text("En avoir plus");
			t2 = space();
			div1 = element("div");
			create_component(ripple1.$$.fragment);
			t3 = space();
			img0 = element("img");
			t4 = space();
			create_component(sharebutton.$$.fragment);
			t5 = space();
			div3 = element("div");
			t6 = space();
			div4 = element("div");
			img1 = element("img");
			t7 = space();
			if_block0.c();
			t8 = space();
			if (if_block1) if_block1.c();
			t9 = space();
			div8 = element("div");
			section0 = element("section");
			t10 = space();
			if_block2.c();
			t11 = space();
			br0 = element("br");
			br1 = element("br");
			br2 = element("br");
			br3 = element("br");
			t12 = space();
			section1 = element("section");
			if (if_block3) if_block3.c();
			t13 = space();
			br4 = element("br");
			br5 = element("br");
			br6 = element("br");
			t14 = space();
			if_block4.c();
			t15 = space();
			div5 = element("div");
			t16 = space();
			br7 = element("br");
			br8 = element("br");
			t17 = space();
			div6 = element("div");
			create_component(maplibre.$$.fragment);
			t18 = space();
			br9 = element("br");
			br10 = element("br");
			t19 = space();
			if (if_block5) if_block5.c();
			t20 = space();
			if (if_block6) if_block6.c();
			t21 = space();
			create_component(menumodal.$$.fragment);
			t22 = space();
			div7 = element("div");
			attr(div0, "class", "en-avoir-plus bottom-centered box-shadow");
			if (!src_url_equal(img0.src, img0_src_value = "/_icons/exit.svg")) attr(img0, "src", img0_src_value);
			attr(img0, "class", "svelte-rabi4t");
			attr(div1, "class", "fab-button small bottom-left box-shadow");
			attr(div2, "class", "footer");
			attr(div3, "class", "headspacer");
			if (!src_url_equal(img1.src, img1_src_value = appRouter.normalizePath(/*halte*/ ctx[0].media.coverImage))) attr(img1, "src", img1_src_value);
			attr(img1, "alt", "");
			attr(img1, "class", "svelte-rabi4t");
			attr(div4, "class", "cover-image svelte-rabi4t");
			attr(section0, "class", "section-poursuivre");
			attr(section1, "class", "section-text");
			set_style(div5, "height", "10px");
			attr(div6, "class", "map-container section-map svelte-rabi4t");
			attr(div7, "class", "footerspacer");
			attr(div8, "class", "column svelte-rabi4t");
		},
		m(target, anchor) {
			mount_component(header, target, anchor);
			insert(target, t0, anchor);
			insert(target, div2, anchor);
			append(div2, div0);
			mount_component(ripple0, div0, null);
			append(div0, t1);
			append(div2, t2);
			append(div2, div1);
			mount_component(ripple1, div1, null);
			append(div1, t3);
			append(div1, img0);
			append(div2, t4);
			mount_component(sharebutton, div2, null);
			insert(target, t5, anchor);
			insert(target, div3, anchor);
			insert(target, t6, anchor);
			insert(target, div4, anchor);
			append(div4, img1);
			append(div4, t7);
			if_blocks[current_block_type_index].m(div4, null);
			insert(target, t8, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, t9, anchor);
			insert(target, div8, anchor);
			append(div8, section0);
			append(div8, t10);
			if_blocks_1[current_block_type_index_1].m(div8, null);
			append(div8, t11);
			append(div8, br0);
			append(div8, br1);
			append(div8, br2);
			append(div8, br3);
			append(div8, t12);
			append(div8, section1);
			if (if_block3) if_block3.m(section1, null);
			append(div8, t13);
			append(div8, br4);
			append(div8, br5);
			append(div8, br6);
			append(div8, t14);
			if_blocks_2[current_block_type_index_2].m(div8, null);
			append(div8, t15);
			append(div8, div5);
			append(div8, t16);
			append(div8, br7);
			append(div8, br8);
			append(div8, t17);
			append(div8, div6);
			mount_component(maplibre, div6, null);
			append(div8, t18);
			append(div8, br9);
			append(div8, br10);
			append(div8, t19);
			if (if_block5) if_block5.m(div8, null);
			append(div8, t20);
			if (if_block6) if_block6.m(div8, null);
			append(div8, t21);
			mount_component(menumodal, div8, null);
			append(div8, t22);
			append(div8, div7);
			current = true;

			if (!mounted) {
				dispose = [
					listen(div0, "click", /*click_handler*/ ctx[16]),
					listen(div1, "click", /*click_handler_1*/ ctx[17])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (!current || dirty[0] & /*halte*/ 1 && !src_url_equal(img1.src, img1_src_value = appRouter.normalizePath(/*halte*/ ctx[0].media.coverImage))) {
				attr(img1, "src", img1_src_value);
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block0 = if_blocks[current_block_type_index];

				if (!if_block0) {
					if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block0.c();
				} else {
					if_block0.p(ctx, dirty);
				}

				transition_in(if_block0, 1);
				if_block0.m(div4, null);
			}

			if (/*halte*/ ctx[0].type == StepType.podcast) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*halte*/ 1) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_9(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(t9.parentNode, t9);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			let previous_block_index_1 = current_block_type_index_1;
			current_block_type_index_1 = select_block_type_1(ctx, dirty);

			if (current_block_type_index_1 === previous_block_index_1) {
				if_blocks_1[current_block_type_index_1].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks_1[previous_block_index_1], 1, 1, () => {
					if_blocks_1[previous_block_index_1] = null;
				});

				check_outros();
				if_block2 = if_blocks_1[current_block_type_index_1];

				if (!if_block2) {
					if_block2 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx);
					if_block2.c();
				} else {
					if_block2.p(ctx, dirty);
				}

				transition_in(if_block2, 1);
				if_block2.m(div8, t11);
			}

			if (/*halteContent*/ ctx[7]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_7(ctx);
					if_block3.c();
					if_block3.m(section1, null);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			let previous_block_index_2 = current_block_type_index_2;
			current_block_type_index_2 = select_block_type_2(ctx, dirty);

			if (current_block_type_index_2 === previous_block_index_2) {
				if_blocks_2[current_block_type_index_2].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks_2[previous_block_index_2], 1, 1, () => {
					if_blocks_2[previous_block_index_2] = null;
				});

				check_outros();
				if_block4 = if_blocks_2[current_block_type_index_2];

				if (!if_block4) {
					if_block4 = if_blocks_2[current_block_type_index_2] = if_block_creators_2[current_block_type_index_2](ctx);
					if_block4.c();
				} else {
					if_block4.p(ctx, dirty);
				}

				transition_in(if_block4, 1);
				if_block4.m(div8, t15);
			}

			const maplibre_changes = {};

			if (dirty[0] & /*haltePoints, halte, parcoursPath, mapIsReady*/ 1049 | dirty[1] & /*$$scope*/ 4) {
				maplibre_changes.$$scope = { dirty, ctx };
			}

			maplibre.$set(maplibre_changes);

			if (/*hasBonus*/ ctx[5] && /*bonusContent*/ ctx[8]) {
				if (if_block5) {
					if_block5.p(ctx, dirty);
				} else {
					if_block5 = create_if_block_4(ctx);
					if_block5.c();
					if_block5.m(div8, t20);
				}
			} else if (if_block5) {
				if_block5.d(1);
				if_block5 = null;
			}

			if (/*hasBiblio*/ ctx[6] && /*biblioContent*/ ctx[9]) {
				if (if_block6) {
					if_block6.p(ctx, dirty);
				} else {
					if_block6 = create_if_block_3(ctx);
					if_block6.c();
					if_block6.m(div8, t21);
				}
			} else if (if_block6) {
				if_block6.d(1);
				if_block6 = null;
			}

			const menumodal_changes = {};

			if (dirty[0] & /*nextHalte, hasBiblio, biblioContent, hasBonus, bonusContent*/ 866 | dirty[1] & /*$$scope*/ 4) {
				menumodal_changes.$$scope = { dirty, ctx };
			}

			if (!updating_open && dirty[0] & /*sectionModalVisible*/ 4) {
				updating_open = true;
				menumodal_changes.open = /*sectionModalVisible*/ ctx[2];
				add_flush_callback(() => updating_open = false);
			}

			menumodal.$set(menumodal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(header.$$.fragment, local);
			transition_in(ripple0.$$.fragment, local);
			transition_in(ripple1.$$.fragment, local);
			transition_in(sharebutton.$$.fragment, local);
			transition_in(if_block0);
			transition_in(if_block1);
			transition_in(if_block2);
			transition_in(if_block4);
			transition_in(maplibre.$$.fragment, local);
			transition_in(menumodal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(header.$$.fragment, local);
			transition_out(ripple0.$$.fragment, local);
			transition_out(ripple1.$$.fragment, local);
			transition_out(sharebutton.$$.fragment, local);
			transition_out(if_block0);
			transition_out(if_block1);
			transition_out(if_block2);
			transition_out(if_block4);
			transition_out(maplibre.$$.fragment, local);
			transition_out(menumodal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(header, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div2);
			destroy_component(ripple0);
			destroy_component(ripple1);
			destroy_component(sharebutton);
			if (detaching) detach(t5);
			if (detaching) detach(div3);
			if (detaching) detach(t6);
			if (detaching) detach(div4);
			if_blocks[current_block_type_index].d();
			if (detaching) detach(t8);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t9);
			if (detaching) detach(div8);
			if_blocks_1[current_block_type_index_1].d();
			if (if_block3) if_block3.d();
			if_blocks_2[current_block_type_index_2].d();
			destroy_component(maplibre);
			if (if_block5) if_block5.d();
			if (if_block6) if_block6.d();
			destroy_component(menumodal);
			mounted = false;
			run_all(dispose);
		}
	};
}

function onGeoLocationStarted() {
	
}

function instance($$self, $$props, $$invalidate) {
	let { halte } = $$props;
	let { nextHalte } = $$props;
	let sectionModalVisible = false;
	let userPosition = geoLocationManager.currentCoords;
	let parcoursPath;
	let parcoursPoints;
	let haltePoints;
	let hasBonus;
	let hasBiblio;
	let halteContent;
	let bonusContent;
	let biblioContent;
	let mapIsReady = false;

	onMount(async () => {
		console.log("halte", halte);
		$$invalidate(4, haltePoints = db.getHalteCoordsForParcours(halte.parentSlug));
		$$invalidate(5, hasBonus = !!halte.contentMap.bonus_url);
		$$invalidate(6, hasBiblio = !!halte.contentMap.bibliography_url);
		$$invalidate(7, halteContent = await db.getHalteContentFor(halte.parentSlug, halte.slug, HalteParentType.parcours));

		if (hasBonus) {
			$$invalidate(8, bonusContent = await db.getBonusContentFor(halte.parentSlug, halte.slug));
		}

		if (hasBiblio) {
			$$invalidate(9, biblioContent = await db.getBiblioContentFor(halte.parentSlug, halte.slug));
		}
	});

	// $:{
	//     console.log("current", halte.slug);
	//     console.log("next", nextHalte);
	// }
	function gotoNextEnChemin() {
		appRouter.show(`/parcours/${halte.parentSlug}/en_chemin/${nextHalte.slug}`);
	}

	function gotoAcceuilParcours() {
		appRouter.show(`/parcours`);
	}

	function gotoToParentParcours() {
		appRouter.show(`/parcours/${halte.parentSlug}`);
	}

	function gotoSection(query) {
		$$invalidate(2, sectionModalVisible = false);
		const offset = -100;
		animateScroll.scrollTo({ element: query, offset, duration: 700 });
	}

	function gotoTop() {
		$$invalidate(2, sectionModalVisible = false);
		animateScroll.scrollToTop();
	}

	onDestroy(() => {
		geoLocationManager.removeEventListener(GeolocationEventType.started, onGeoLocationStarted);
		geoLocationManager.removeEventListener(GeolocationEventType.significantCoords, onGeoLocationUpdate);
		geoLocationManager.removeEventListener(GeolocationEventType.stopped, onGeoLocationStopped);
	});

	function onGeoLocationUpdate(event) {
		userPosition = event.value;
		flyToParcoursAndUser();
	}

	function onGeoLocationStopped() {
		userPosition = null;
		flyToParcoursAndUser();
	}

	function flyToParcoursAndUser() {
		let points = parcoursPoints.slice();

		if (userPosition && geoLocationManager.isStarted) {
			points.push(userPosition.coords);
		}

		const bbox = getBbox(points);
		const flyToOptions = { bounds: bbox, padding: 30 };
		flyToProvider.provide(flyToOptions);
	}

	async function onMapLoaded() {
		$$invalidate(10, mapIsReady = true);
		geoLocationManager.addEventListener(GeolocationEventType.started, onGeoLocationStarted);
		geoLocationManager.addEventListener(GeolocationEventType.significantCoords, onGeoLocationUpdate);
		geoLocationManager.addEventListener(GeolocationEventType.stopped, onGeoLocationStopped);
		const parcours = db.getParcoursWithSlug(halte.parentSlug);

		if (parcours.media.path) {
			$$invalidate(3, parcoursPath = await db.getParcoursPath(parcours.slug));
		} else {
			$$invalidate(3, parcoursPath = JSON.parse(lineFeatureCollectionFromPoints(haltePoints)));
		}

		parcoursPoints = parcoursPath.features.find(feature => feature.geometry.type == "LineString").geometry.coordinates;
		flyToParcoursAndUser();
	}

	const click_handler = () => $$invalidate(2, sectionModalVisible = true);
	const click_handler_1 = () => gotoSection('.section-poursuivre');
	const click_handler_2 = () => gotoSection('.section-text');
	const click_handler_3 = () => gotoSection('.section-map');
	const click_handler_4 = () => gotoSection('.section-bonus');
	const click_handler_5 = () => gotoSection('.section-bibliography');
	const click_handler_6 = () => gotoSection('.section-poursuivre');

	function menumodal_open_binding(value) {
		sectionModalVisible = value;
		$$invalidate(2, sectionModalVisible);
	}

	$$self.$$set = $$props => {
		if ('halte' in $$props) $$invalidate(0, halte = $$props.halte);
		if ('nextHalte' in $$props) $$invalidate(1, nextHalte = $$props.nextHalte);
	};

	return [
		halte,
		nextHalte,
		sectionModalVisible,
		parcoursPath,
		haltePoints,
		hasBonus,
		hasBiblio,
		halteContent,
		bonusContent,
		biblioContent,
		mapIsReady,
		gotoNextEnChemin,
		gotoAcceuilParcours,
		gotoSection,
		gotoTop,
		onMapLoaded,
		click_handler,
		click_handler_1,
		click_handler_2,
		click_handler_3,
		click_handler_4,
		click_handler_5,
		click_handler_6,
		menumodal_open_binding
	];
}

class HaltePodcastAndVideo extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { halte: 0, nextHalte: 1 }, null, [-1, -1]);
	}
}

export default HaltePodcastAndVideo;